/* eslint-disable react/no-unescaped-entities */
import React, { FC } from 'react';

// import WorldLogo from '@components/ui/WorldLogo/WorldLogo';
import {
  HotelDetailReviewViewModel,
  HotelFeatureViewModel,
  RoomLowestPriceViewModel,
} from '@api/index';
import CustomIcon from '@components/utils/CustomIcon';
import { MapPin2Line } from '@assets/icons';
import { Col, Row } from '@components/formStyles';
import Markdown from '@components/utils/Markdown';
import {
  formatCurrency,
  removeBrTagFromMarkdown,
  removeImgTagFromMarkdown,
} from '@utils/utils';
import { RoomInfo } from '@components/views/hotel/detail/components/room-information/DetailedRoomStyle';
import Price from '@components/ui/price';
import { OrText } from '@uikit/milePriceBadge/styled';
import MilePriceBadge from '@uikit/milePriceBadge';
import DiscountLabel from '@components/ui/labels/discount/DiscountLabel';
import ScoringBanner from '@components/views/hotel/detail/components/detail-scoring';

import {
  Container,
  ReadMore,
  SubtitleSeperator,
  IconText,
  DynamicRow,
  Title,
  Scoring,
  TopWrapper,
  BotWrapper,
  PriceWrapper,
  DescriptionWrapper,
  StyledButton,
  PriceStartLabel,
} from './SummaryCardStyle';

export interface SummaryCardProps {
  onNavigate: () => void;
  onReadMore?: () => void;
  toggleMap?: () => void;
  name: string;
  boardType: string;
  description: string;
  prices?: RoomLowestPriceViewModel;
  features?: HotelFeatureViewModel[];
  roomInformation?: string;
  onClickTripAdvisor?: () => void;
  address?: string;
  ratings?: HotelDetailReviewViewModel;
  expedia?: boolean;
}

export const ReadMoreSection: FC<{ text: string; onClick?: () => void }> = ({
  text,
  onClick,
}) => <ReadMore onClick={onClick}>{text}</ReadMore>;

const SummaryCard: FC<SummaryCardProps> = ({
  onNavigate,
  onReadMore,
  name,
  boardType,
  description,
  prices,
  roomInformation,
  onClickTripAdvisor,
  address,
  ratings,
  expedia,
}) => {
  return (
    <Container>
      <TopWrapper>
        <DynamicRow alignItems='center'>
          <Col>
            <Title>{name}</Title>
            <DynamicRow>
              {address ? (
                <Row alignItems='center'>
                  <CustomIcon
                    icon={MapPin2Line}
                    fontSize={16}
                    paletteColor='grey600'
                  />
                  <IconText>{address}</IconText>
                  <SubtitleSeperator />
                </Row>
              ) : null}

              <IconText isDark>{boardType}</IconText>
            </DynamicRow>
          </Col>
        </DynamicRow>

        {ratings?.rating ? (
          <Scoring onClick={onClickTripAdvisor}>
            <ScoringBanner
              generalRatingImage={ratings?.generalRatingImage}
              totalScoring={ratings?.rating}
              subratings={ratings?.subratings}
            />
          </Scoring>
        ) : null}
      </TopWrapper>

      <BotWrapper alignItems='center' justifyContent='space-between'>
        {description ? (
          <DescriptionWrapper>
            <Markdown
              text={removeImgTagFromMarkdown(
                removeBrTagFromMarkdown(description)
              ).substring(0, 360)}
            />

            <ReadMoreSection text='Devamını Oku' onClick={onReadMore} />
          </DescriptionWrapper>
        ) : (
          <div />
        )}
        <PriceWrapper>
          <RoomInfo>{roomInformation}</RoomInfo>

          <Row style={{ marginTop: 8 }} justifyContent='flex-end'>
            {prices?.discountRatio ? (
              <DiscountLabel discount={prices.discountRatio} />
            ) : null}
          </Row>

          {prices?.price ? (
            <Price
              price={prices.price}
              originalPrice={prices.originalPrice}
              orginalDiscountedPrice={prices.originalDiscountedPrice}
              originalPriceSize={14}
              originalPriceCurrency={formatCurrency(
                prices.originalCurrencyCode
              )}
              currency={formatCurrency(prices.currencyCode)}
              isExpedia={expedia}
            />
          ) : null}
          {prices?.milePrice ? (
            <>
              <OrText> ya da</OrText>
              <MilePriceBadge milePrice={prices?.milePrice} />
            </>
          ) : null}
          {prices?.price ? (
            <PriceStartLabel>'den başlayan fiyatlarla</PriceStartLabel>
          ) : null}
          <StyledButton onClick={onNavigate}>Oda Seç</StyledButton>
        </PriceWrapper>
      </BotWrapper>
    </Container>
  );
};

export default SummaryCard;
